import { render, staticRenderFns } from "./putbill.vue?vue&type=template&id=9b8a6000&scoped=true&"
import script from "./putbill.vue?vue&type=script&lang=js&"
export * from "./putbill.vue?vue&type=script&lang=js&"
import style0 from "./putbill.vue?vue&type=style&index=0&id=9b8a6000&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8a6000",
  null
  
)

export default component.exports